
document.addEventListener('DOMContentLoaded', function () {

    // Get search query from URL
    const params = new URLSearchParams(window.location.search);
    const searchQuery = params.get('s');

    if (searchQuery !== null) {

        // Open search overlay
        const searchForm = document.getElementById('search-form-desktop');
        if (searchForm) {
            searchForm.classList.add('display-search');
            searchForm.classList.remove('d-none');
        }

        // Populate search input
        const searchField = document.getElementById('search-field-desktop');
        if (searchField) {
            searchField.value = searchQuery;
            searchField.focus();
        }

        // Update aria-expanded
        const searchMenuContainer = document.querySelector('.search-menu-container');
        if (searchMenuContainer) {
            searchMenuContainer.setAttribute('aria-expanded', 'true');
        }
    }

});
